import React from 'react'
import { TextField } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import InputBox from '../../../../atomic/inputbox/InputBox'
import WeekdayCheckboxes from '../../ServingDaysCheckBox'
import { SectionCard } from './SectionCard'
import { EditableField } from './EditableField'
import styles from './styles.module.css'

export const ProductDetailsSection = ({
  productName, setProductName,
  recipeWith, setRecipeWith,
  description, setDescription,
  selectedDays, setSelectedDays,
  errors,
  editingFields,
  startEdit,
  cancelField,
  onChangeHandler
}) => (
  <SectionCard title='Product Details'>
    <div className={styles.detailsColumn}>

      <EditableField
        label='Product Name'
        displayValue={productName}
        isEditing={!!editingFields.product_name}
        onEdit={() => startEdit('product_name')}
        onCancel={() => cancelField('product_name', setProductName)}
      >
        <InputBox
          type='text'
          label='Product Name'
          size='small'
          sx={{ width: '100%', height: 'auto' }}
          name='productname'
          value={productName}
          maxLength='50'
          error={!!errors.productname}
          inputErrorMsg={errors.productname || 'Up to 50 characters.'}
          onChange={onChangeHandler('productname')}
        />
      </EditableField>

      <EditableField
        label='Recipe With'
        displayValue={recipeWith}
        isEditing={!!editingFields.recipe_with}
        onEdit={() => startEdit('recipe_with')}
        onCancel={() => cancelField('recipe_with', setRecipeWith)}
      >
        <InputBox
          type='text'
          label='Recipe With'
          size='small'
          sx={{ width: '100%', height: 'auto' }}
          name='recipewith'
          value={recipeWith}
          maxLength='25'
          error={!!errors.recipewith}
          inputErrorMsg={errors.recipewith || 'Optional. Up to 25 characters.'}
          onChange={onChangeHandler('recipewith')}
        />
      </EditableField>

      <div className={styles.descRow}>
        <div className={styles.descColumn}>
          <EditableField
            label='Product Description'
            fillHeight
            displayValue={
              description
                ? description.length > 80
                  ? description.slice(0, 80) + '…'
                  : description
                : ''
            }
            isEditing={!!editingFields.product_description}
            onEdit={() => startEdit('product_description')}
            onCancel={() => cancelField('product_description', setDescription)}
          >
            <TextField
              label='Product Description'
              multiline
              minRows={11}
              maxRows={14}
              fullWidth
              value={description}
              onChange={onChangeHandler('description')}
              error={!!errors.description}
              helperText={errors.description || 'Up to 500 characters.'}
              InputLabelProps={{
                sx: {
                  color: 'gray',
                  '&.Mui-focused': { color: 'rgb(255, 123, 41)' }
                }
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                  backgroundColor: '#fff',
                  '&.Mui-focused fieldset': { borderColor: 'rgb(24, 20, 54)' }
                }
              }}
            />
          </EditableField>
        </div>
        <div className={styles.weekdaysWrapper}>
          <div className={styles.weekdaysEditorShell}>
            {editingFields.serving_days ? (
              <>
                <WeekdayCheckboxes
                  selectedDays={selectedDays}
                  setSelectedDays={setSelectedDays}
                />
                <button
                  onClick={() => cancelField('serving_days', setSelectedDays)}
                  title='Cancel editing'
                  className={styles.weekdaysCancelBtn}
                >
                  ✕
                </button>
              </>
            ) : (
              <>
                <div className={styles.weekdaysViewCard}>
                  <div className={styles.weekdaysViewLabel}>Select Days</div>
                  <div className={styles.weekdaysViewHint}>
                    Select the days this product will be available
                  </div>
                  {selectedDays?.length ? (
                    <div className={styles.weekdaysSelectedList}>
                      {selectedDays.map(day => (
                        <span key={day} className={styles.weekdaysSelectedItem}>
                          {day}
                        </span>
                      ))}
                    </div>
                  ) : (
                    <div className={styles.weekdaysEmptyValue}>No days selected</div>
                  )}
                </div>
                <button
                  onClick={() => startEdit('serving_days')}
                  title='Edit Select Days'
                  className={styles.weekdaysEditBtn}
                >
                  <EditIcon sx={{ color: '#181436', fontSize: 18 }} />
                </button>
              </>
            )}
          </div>
        </div>
      </div>

    </div>
  </SectionCard>
)
